import React from "react";
import JsonView from "./JsonView";
import Util from "../Util";
import $ from "jquery";

const STATE_INCREASE_MAX_STOP_DAYS = 0
const STATE_UPLOAD_CCLOCAL = 1

class SheldonPayapiCmd extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      cfgName: 'serverurl',
      cfgValue: '',
      type: '',
      path: '',
      content: '',
      uploadState: 0,
    }
  }

  isValidState(command, state) {
    if (command !== state) {
      this.setState({
        content: <div>
          Please execute step: {state + 1}
        </div>
      });
      return false;
    } else {
      this.setState({
        content: <div>Executed step: {state + 1}</div>,
        uploadState: (state + 1) % 2,
      });
      return true;
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleButtonClick(type, event) {
    event.preventDefault();

    let {hostInfo, onStatusChanged} = this.props;
    let {ip} = hostInfo;

    if (this.unmounted) return;

    if (hostInfo.isVPNKskType && !Util.isValidIpAddress(ip)) {
      this.setState({
        content: <span style={{color: 'red'}}>Invalid ip: {ip}</span>
      });
      return;
    }

    let payapi = Util.getPayApiPath(hostInfo);

    let path = '';
    let method = 'GET';
    switch (type) {
      case 'apriva/forcelocal':
        path = `${payapi}/cmd?forcelocal=1`;
        break;
      case 'apriva/lock':
        path = `${payapi}/cmd?lock=1`;
        break;
      case 'apriva/unlock':
        path = `${payapi}/cmd?unlock=1`;
        break;
      case 'heardland/lock':
        path = `${payapi}/cmd?lock=14`;
        break;
      case 'heardland/unlock':
        path = `${payapi}/cmd?unlock=14`;
        break;
      case 'cardsmith/lock':
        path = `${payapi}/cmd?lock=3`;
        break;
      case 'cardsmith/unlock':
        path = `${payapi}/cmd?unlock=3`;
        break;
      case 'cclocal/increasemaxstopdays':
        if(!this.isValidState(STATE_INCREASE_MAX_STOP_DAYS, this.state.uploadState)) return;
        path = `${payapi}/cmd?cclocalmaxstopdays=28`;
        break;
      case 'cclocal/uploadlocal':
        if(!this.isValidState(STATE_UPLOAD_CCLOCAL, this.state.uploadState)) return;
        path = `${payapi}/cmd?uploadlocal=yes`;
        break;
      case 'cclocal/decreasemaxstopdays':
        path = `${payapi}/cmd?cclocalmaxstopdays=14`;
        break;
    }

    if (this.inProgress) {
      this.setState({
        content: <div>
          <i className="fa fa-spinner fa-spin fa-3x fa-fw"/>
          <div>Request in Progress!</div>
        </div>
      });
      return;  // stop when other request in progress
    }

    this.setState({
      type: type,
      path: path,
      content: <i className="fa fa-spinner fa-spin fa-3x fa-fw"/>
    });

    this.inProgress = true;

    $.ajax({url: path, dataType: 'json', method: method})
      .always((arg) => {
        this.inProgress = false;
        onStatusChanged(); // good response could return with status other than 200
      })
      .done(data => {
        this.setState({
          content: <JsonView title={path} data={data}/>
        });
      })
      .fail((jqXHR) => {
        this.setState({
          content: <span style={{color: ''}}>{jqXHR.responseText}</span>
        });
      })
  }

  render() {
    let {panelHeight} = this.props;
    let {type} = this.state;
    return (
      <div className="sheldon-content-wrapper">
        <h2>payapi Commands</h2>
        <div style={{margin: '20px 0'}}>For testing and in cases where processor is having issue, we can force payapi to
          local mode for specific processor.
        </div>
        <div className="sheldon-buttons">
          <div className="pure-u-1-3">
            <span style={{paddingRight: 10}}>Apriva:</span>
            {/*
            <button className={type == 'apriva/forcelocal' ? 'pure-button pure-button__selected' : 'pure-button'}
                    onClick={this.handleButtonClick.bind(this, 'apriva/forcelocal')}>
              Force Local
            </button>
*/}
            <button className={type == 'apriva/lock' ? 'pure-button pure-button__selected' : 'pure-button'}
                    onClick={this.handleButtonClick.bind(this, 'apriva/lock')}>
              Lock
            </button>
            <button className={type == 'apriva/unlock' ? 'pure-button pure-button__selected' : 'pure-button'}
                    onClick={this.handleButtonClick.bind(this, 'apriva/unlock')}>
              Unlock
            </button>
          </div>
          <div className="pure-u-1-3">
            <span style={{paddingRight: 10}}>Heartland:</span>
            <button className={type == 'heardland/lock' ? 'pure-button pure-button__selected' : 'pure-button'}
                    onClick={this.handleButtonClick.bind(this, 'heardland/lock')}>
              Lock
            </button>
            <button className={type == 'heardland/unlock' ? 'pure-button pure-button__selected' : 'pure-button'}
                    onClick={this.handleButtonClick.bind(this, 'heardland/unlock')}>
              Unlock
            </button>
          </div>
          <div className="pure-u-1-3">
            <span style={{paddingRight: 10}}>CardSmith:</span>
            <button className={type == 'cardsmith/lock' ? 'pure-button pure-button__selected' : 'pure-button'}
                    onClick={this.handleButtonClick.bind(this, 'cardsmith/lock')}>
              Lock
            </button>
            <button className={type == 'cardsmith/unlock' ? 'pure-button pure-button__selected' : 'pure-button'}
                    onClick={this.handleButtonClick.bind(this, 'cardsmith/unlock')}>
              Unlock
            </button>
          </div>

          <div>
            {/* Vertical Spacer */}
            <div style={{display: 'block', height: '20px'}}></div>
            <div style={{margin: '20px 0'}}>For uploading cclocal transactions > 14 days, perform steps 1 - 3 in order</div>

            <div className="pure-1-3">
              <div>
                <span style={{paddingRight: 10}}>1. Increase Max Stop Days:</span>
                {/* Button to increase max days, Button to upload cclocal */}
                <button className={
                  type == 'cclocal/increasemaxstopdays' ? 'pure-button pure-button__selected' : 'pure-button'
                }
                        onClick={this.handleButtonClick.bind(this, 'cclocal/increasemaxstopdays')}>
                  Increase max stop days
                </button>
              </div>

              <div>
                <span style={{paddingRight: 10}}>2. Process/Upload cclocal:</span>
                <button className={type == 'cclocal/uploadlocal' ? 'pure-button pure-button__selected' : 'pure-button'}
                        onClick={this.handleButtonClick.bind(this, 'cclocal/uploadlocal')}>
                  Process/upload cclocal
                </button>
              </div>

              <div>
                <span style={{paddingRight: 10}}>3. Reset Max Stop Days:&emsp; </span>
                <button className={type == 'cclocal/decreasemaxstopdays' ? 'pure-button pure-button__selected' : 'pure-button'}
                        onClick={this.handleButtonClick.bind(this, 'cclocal/decreasemaxstopdays')}>
                  Reset max stop days
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="sheldon-content">
          <div style={{height: panelHeight - 280, overflow: 'auto'}} ref="content">
            {this.state.content}
          </div>
        </div>
      </div>

    );
  }
}

export default SheldonPayapiCmd;



// WEBPACK FOOTER //
// ./src/components/SheldonPayapiCmd.js